import controller from './subcase-state-change-modal';
import template from './subcase-state-change-modal.pug';

class SubcaseStateChangeService {
  /* @ngInject */
  constructor($uibModal, $http) {
    this.$uibModal = $uibModal;
    this.$http = $http;
  }

  open(subCase) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          data: () => ({ subCase }),
        },
      })
      .result;
  }
}

export default SubcaseStateChangeService;



// WEBPACK FOOTER //
// ./client/components/subcase-state-change-modal/subcase-state-change-modal.service.js